import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BasicInfoSecondHeadlineModel } from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
var FormSecondHeadlineInfoComponent = /** @class */ (function () {
    function FormSecondHeadlineInfoComponent(headerService, copyService, formBuilder, parameterService, bitacoraService, navigationService, abreCuentasService, requestService, helperService) {
        this.headerService = headerService;
        this.copyService = copyService;
        this.formBuilder = formBuilder;
        this.parameterService = parameterService;
        this.bitacoraService = bitacoraService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.helperService = helperService;
        this.headerService.show(true, true, true);
        this.formGroup = this.formBuilder.group({});
        this.date_button = false;
        this.date_button_expedition = false;
        this.maximumDate = this.helperService.formatDateCalendar(new Date());
        var date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 216);
        this.minDateBirth = this.helperService.formatDateCalendar(date_e);
        date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 888);
        this.maxDateBirth = this.helperService.formatDateCalendar(date_e);
        this.minDateExp = this.helperService.formatDateCalendar(new Date());
        date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 600);
        this.maxDateExp = this.helperService.formatDateCalendar(date_e);
        this.setBasicInfo();
    }
    FormSecondHeadlineInfoComponent.prototype.ngOnInit = function () {
        this.select_doc_type = this.parameterService.getSetting(OpEnum.DOC_TYPE);
        this.select_gender_type = this.parameterService.getSetting(OpEnum.GENDER_TYPE);
        this.formGroup = new FormGroup({
            name_second_headline: new FormControl(this.basicSecondHeadline.name_second_headline, Validators.required),
            lastname_second_headline: new FormControl(this.basicSecondHeadline.lastname_second_headline, Validators.required),
            doc_type_second_headline: new FormControl(this.basicSecondHeadline.doc_type_second_headline, Validators.required),
            doc_number_second_headline: new FormControl(this.basicSecondHeadline.doc_number_second_headline, [Validators.required, Validators.minLength(2)]),
            gender_second_headline: new FormControl(this.basicSecondHeadline.gender_second_headline, Validators.required),
        });
        var value_date = this.basicSecondHeadline.birthdate_second_headline.toString();
        this.date = value_date === 'Invalid Date' ? '' : this.basicSecondHeadline.birthdate_second_headline;
        this.date_button = value_date === 'Invalid Date' ? false : true;
        var value_date_expedition = this.basicSecondHeadline.expeditiondate_second_headline.toString();
        this.date_expedition = value_date_expedition === 'Invalid Date' ? '' : this.basicSecondHeadline.expeditiondate_second_headline;
        this.date_button_expedition = value_date_expedition === 'Invalid Date' ? false : true;
    };
    FormSecondHeadlineInfoComponent.prototype.doc_type_change = function (e) {
        var target = e.value.id;
        var max_length_input = target === '1' ? 10 : (target === '2' ? 7 : 12);
        this.formGroup.controls.doc_number_second_headline.setValidators([Validators.required,
            Validators.minLength(2), Validators.maxLength(max_length_input)]);
        this.formGroup.controls.doc_number_second_headline.updateValueAndValidity();
        this.target_doc_type = {
            type_input: target === '1' || target === '2' ? 'number' : 'text',
            max_length: max_length_input,
        };
    };
    FormSecondHeadlineInfoComponent.prototype.next = function () {
        this.restrictiveList();
        var data = JSON.stringify(this.formGroup.value);
        var bitacoraEvent = "second headline info_" + data;
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.basic_info = {
            name_second_headline: this.formGroup.controls.name_second_headline.value,
            lastname_second_headline: this.formGroup.controls.lastname_second_headline.value,
            doc_type_second_headline: this.formGroup.controls.doc_type_second_headline.value.type,
            doc_number_second_headline: this.formGroup.controls.doc_number_second_headline.value,
            birthdate_second_headline: this.date,
            expeditiondate_second_headline: this.date_expedition,
            gender_second_headline: this.formGroup.controls.gender_second_headline.value.short_name,
        };
        this.abreCuentasService.setBasicInfoSecondHeadline(this.basic_info);
        this.navigationService.nextStep();
    };
    FormSecondHeadlineInfoComponent.prototype.restrictiveList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var restrictive_params, fullName, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restrictive_params = this.parameterService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
                        fullName = this.formGroup.controls.name_second_headline.value + " " + this.formGroup.controls.lastname_second_headline.value;
                        body = {
                            data: {
                                client_name: fullName,
                                document: {
                                    number: this.formGroup.controls.doc_number_second_headline.value,
                                },
                                user_name: restrictive_params.user_name,
                                employee_id: restrictive_params.employee_id,
                                application: restrictive_params.application,
                                priority: restrictive_params.priority,
                                reference_type: restrictive_params.reference_type,
                                transaction_type: restrictive_params.transaction_type,
                            },
                        };
                        return [4 /*yield*/, this.requestService.getRestrictiveList(body).then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var data;
                                return tslib_1.__generator(this, function (_a) {
                                    data = {
                                        list_query_status: {
                                            status_code: res.data.status_code,
                                        },
                                    };
                                    this.abreCuentasService.setProspectResponseSecondHeadLine(data);
                                    if (res.data.status_code === '5') {
                                        this.navigationService.navigateToGeneralInformation('107');
                                        return [2 /*return*/];
                                    }
                                    return [2 /*return*/];
                                });
                            }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormSecondHeadlineInfoComponent.prototype.reactiveInputText = function (e) {
        if (e === 'name') {
            var control = this.formGroup.controls.name_second_headline;
            control.setValue(control.value.replace(new RegExp(/[^A-Z a-z]/), ''));
        }
        else {
            var control = this.formGroup.controls.lastname_second_headline;
            control.setValue(control.value.replace(new RegExp(/[^A-Z a-z]/), ''));
        }
    };
    FormSecondHeadlineInfoComponent.prototype.reactiveInputChange = function () {
        var control = this.formGroup.controls.doc_number_second_headline;
        control.setValue(control.value.slice(0, this.target_doc_type.max_length));
        if (this.target_doc_type.type_input === 'number') {
            control.setValue(control.value.replace(new RegExp(/[^\d]/), ''));
        }
        else {
            control.setValue(control.value.replace(new RegExp(/[^A-Za-z0-9]/), ''));
        }
    };
    FormSecondHeadlineInfoComponent.prototype.reactiveDatePicker = function (type, e) {
        if (type === 'birthdate') {
            this.date_button = e.target.value !== '' ? true : false;
            this.date = e.target.value;
        }
        else {
            this.date_button_expedition = e.target.value !== '' ? true : false;
            this.date_expedition = e.target.value;
        }
    };
    FormSecondHeadlineInfoComponent.prototype.setBasicInfo = function () {
        var basicSecondInfo = this.abreCuentasService.getBasicInfoSecondHeadline();
        if (!basicSecondInfo) {
            this.basicSecondHeadline = new BasicInfoSecondHeadlineModel();
            this.basicSecondHeadline.name_second_headline = '';
            this.basicSecondHeadline.lastname_second_headline = '';
            this.basicSecondHeadline.doc_type_second_headline = 0;
            this.basicSecondHeadline.doc_number_second_headline = '';
            this.basicSecondHeadline.birthdate_second_headline = new Date('dd/mm/yyyy');
            this.basicSecondHeadline.expeditiondate_second_headline = new Date('dd/mm/yyyy');
            this.basicSecondHeadline.gender_second_headline = '';
            this.abreCuentasService.setBasicInfoSecondHeadline(this.basicSecondHeadline);
            return;
        }
        this.basicSecondHeadline = basicSecondInfo;
        return;
    };
    return FormSecondHeadlineInfoComponent;
}());
export { FormSecondHeadlineInfoComponent };
